import { ChatSharableInterface } from "./chat-sharable-interface";
import { User } from "./user";
import { SessionItemWrapper } from "./session-item-wrapper";

export interface SessionData {
  id?: number;
  libraryId?: number;
  modelId?: number;
  type?: string;
  name?: string;
  tags?: string;
  nbRepeat?: number;
  intensity?: number;
  totalTime?: number;
  comment?: string;
  adn?: string;
  translations?: any;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  sessionItemWrappers?: SessionItemWrapper[];

  creater?: User;
  availableLangIds: number[];
  libraryTag?: string;
}


export class Session implements ChatSharableInterface {
  public static readonly SESSION_TYPE_MODEL: string = 'MODEL';
  public static readonly SESSION_TYPE_PLANNED: string = 'PLANNED';
  public static readonly SESSION_TYPE_PERSONALIZED: string = 'PERSONALIZED';

  public static getNonTranslatableFields(): string[] { return ['id', 'libraryId', 'modelId', 'type', 'nbRepeat', 'intensity', 'totalTime', 'comment', 'adn', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return ['name', 'tags']; }
  public static getFields(): string[] { return ['id', 'libraryId', 'modelId', 'type', 'name', 'tags', 'nbRepeat', 'intensity', 'totalTime', 'comment', 'adn', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  libraryId?: number;
  modelId?: number;
  type?: string;
  name?: string;
  tags?: string;
  nbRepeat?: number;
  intensity?: number;
  totalTime?: number;
  translations?: any;
  comment?: string;
  adn?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];
  sessionItemWrappers?: SessionItemWrapper[];
  creater?: User;
  availableLangIds: number[];
  libraryTag?: string;

  public static fromAPI(data: SessionData): Session {
    if (data.creater) {
      data.creater = User.fromAPI(data.creater);
    }
    if (data.sessionItemWrappers) {
      data.sessionItemWrappers = SessionItemWrapper.fromAPIList(data.sessionItemWrappers);
    }

    let translationData: any = {};

    for (let i = 0; i < data.translations?.length; i++) {
      if (data.translations[i]['sessionId'] === data['id']) {
        translationData = data.translations[i];
        i = data.translations?.length;
      }
    }
    return new Session({
      id: data.id,
      libraryId: data.libraryId,
      modelId: data.modelId,
      type: data.type,
      name: translationData.name ?? data.name,
      tags: translationData.tags ?? data.tags,
      nbRepeat: data.nbRepeat,
      intensity: data.intensity,
      totalTime: data.totalTime,
      comment: data.comment,
      adn: data.adn,
      createDate: data.createDate,
      createrId: data.createrId,
      updateDate: data.updateDate,
      updaterId: data.updaterId,
      deleteDate: data.deleteDate,
      deleterId: data.deleterId,
      creater: data.creater,

      rights: data.rights,

      sessionItemWrappers: data.sessionItemWrappers,

      translations: data.translations,
      availableLangIds: data.availableLangIds,
      libraryTag: data.libraryTag,
    });
  }

  public static fromAPIList(data: SessionData[]): Session[] {
    return data.map((item: SessionData) => Session.fromAPI(item));
  }

  constructor({id, libraryId, modelId, type, name, tags, nbRepeat, intensity, totalTime, comment, adn, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
              translations, rights, sessionItemWrappers, creater, availableLangIds, libraryTag} : SessionData) {
    this.id = id;
    this.libraryId = libraryId;
    this.modelId = modelId;
    this.type = type;
    this.name = name;
    this.tags = tags;
    this.nbRepeat = nbRepeat;
    this.intensity = intensity;
    this.totalTime = totalTime;
    this.comment = comment;
    this.adn = adn;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
    this.creater = creater;

    this.rights = rights;

    this.sessionItemWrappers = sessionItemWrappers;

    this.translations = translations;
    this.availableLangIds = availableLangIds;
    this.libraryTag = libraryTag;
  }

  public toJson(): SessionData {
    return {
      id: this.id,
      libraryId: this.libraryId,
      modelId: this.modelId,
      type: this.type,
      name: this.name,
      tags: this.tags,
      nbRepeat: this.nbRepeat,
      intensity: this.intensity,
      totalTime: this.totalTime,
      comment: this.comment,
      adn: this.adn,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId,
      availableLangIds: this.availableLangIds,
      libraryTag: this.libraryTag,
    };
  }


  public chatSharableId(): number {
    return this.id ?? 0;
  }

  public chatSharableName(): string {
    return this.name ?? '';
  }

  public chatSharableType(): string {
    return 'sessions';
  }
}
